import React from "react";

const TableContent = ({ children }) => {
  return (
    <tbody>{children}</tbody>
  );
};

export default TableContent;
